
import {lazy} from 'react';

// console.log(import('../../pages/uploadAddress/index.js'));

const UploadAddress = [
// {
//   title: '零食机上报选址-首页',
//   path: '/uploadAddress/home',
//   key: 'UploadAddressHome',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressHome' */ '../pages/uploadAddress/home')),
//   exact: true
// }, {
//   title: '零食机上报选址-企业表单1',
//   path: '/uploadAddress/form/company_step_1',
//   key: 'UploadAddressCompanyStep1',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressCompanyStep1' */ '../pages/uploadAddress/form/company/form.step1')),
//   exact: true
// }, {
//   title: '零食机上报选址-企业表单2',
//   path: '/uploadAddress/form/company_step_2',
//   key: 'UploadAddressCompanyStep2',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressCompanyStep2' */ '../pages/uploadAddress/form/company/form.step2')),
//   exact: true
// }, {
//   title: '零食机上报选址-添加选址',
//   path: '/uploadAddress/form/full',
//   key: 'UploadAddressForm',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressForm' */ '../pages/uploadAddress/form/form.full')),
//   exact: true
// }, {
//   title: '零食机上报选址-选址记录',
//   path: '/uploadAddress/record',
//   key: 'UploadAddressRecord',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressRecord' */ '../pages/uploadAddress/record')),
//   exact: true
// }, {
//   title: '零食机上报选址-登录',
//   path: '/uploadAddress/login',
//   key: 'UploadAddressLogin',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressLogin' */ '../pages/uploadAddress/login')),
//   exact: true
// }, {
//   title: '零食机上报选址-表单提交完成',
//   path: '/uploadAddress/complete',
//   key: 'UploadAddressComplete',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressComplete' */ '../pages/uploadAddress/complete')),
//   exact: true
// }, 

{
  title: '零食机上报选址-合同签约',
  path: '/uploadAddress/contract',
  key: 'UploadAddressContract',
  component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressContract' */ '../pages/uploadAddress/contract')),
  exact: true
}, {
  title: '零食机上报选址-合同签约-创建供应商',
  path: '/uploadAddress/contract/supply',
  key: 'UploadAddressContractSupply',
  component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressContract' */ '../pages/uploadAddress/contract/createSupplyInfo')),
  exact: true
},
// {
//   title: '零食机上报选址-业务洽谈',
//   path: '/uploadAddress/business',
//   key: 'UploadAddressBusiness',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressBusiness' */ '../pages/uploadAddress/business')),
//   exact: true
// },
{
  title: '零食机上报选址-上传附件',
  path: '/uploadAddress/attachment',
  key: 'UploadAddressAttachment',
  component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressAttachment' */ '../pages/uploadAddress/attachment/attachment.component')),
  exact: true
}, 
// {
//   title: '零食机上报选址-城市暂未开放合作',
//   path: '/uploadAddress/result',
//   key: 'UploadAddressResult',
//   component: lazy(() => import(/* webpackChunkName: 'snackMachine/UploadAddressResult' */ '../pages/uploadAddress/result/result.component')),
//   exact: true
// }
];

export default UploadAddress;
